export default {
  install(Vue, options) {
    const store = options.store;
    let registrationStatus = null;
    function setRegistrationStatus(response) {
      registrationStatus = response.data.data.registrationStatus;
    }

    function handleFailed() {
      return null;
    }

    const fetchRegistrationStatus = async () => {
      const endpoint =
        store.state.config.configurationData.common_module.profileManagement
          .getProfileBySgid;
      await Vue.prototype.$api.post(
        endpoint,
        {},
        setRegistrationStatus,
        handleFailed
      );
      return registrationStatus;
    };

    Vue.prototype.$profile = {
      getRegistrationStatus: fetchRegistrationStatus
    };
  }
};
